import { styled, Typography } from '@mui/material';
import React from 'react';
import { Colors } from '../themes';
import { t } from 'i18next';

const Container = styled('div')({
  position: 'absolute',
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  overflow: 'hidden',
  backgroundColor: 'transparent',
  pointerEvents: 'none',
});

const Ribbon = styled('div')({
  position: 'absolute',
  padding: '10px 3em',
  zIndex: 9,
  textAlign: 'center',
  boxShadow: '0 0 10px rgba(0,0,0,.3)',
  backgroundColor: Colors.alternateBase,
  pointerEvents: 'none',
});

const getPositionStyle = (position: CornerRibbonProps['position']): React.CSSProperties => {
  switch (position) {
    case 'top-left':
      return {
        top: 0,
        left: 0,
        transform: 'translateY(-100%) rotate(-90deg) translateX(-70.71067811865476%) rotate(45deg)',
        transformOrigin: 'bottom left',
        WebkitTransform:
          'translateY(-100%) rotate(-90deg) translateX(-70.71067811865476%) rotate(45deg)',
      };
    case 'top-right':
      return {
        top: 0,
        right: 0,
        transform: 'translateY(-100%) rotate(90deg) translateX(70.71067811865476%) rotate(-45deg)',
        transformOrigin: 'bottom right',
        WebkitTransform:
          'translateY(-100%) rotate(90deg) translateX(70.71067811865476%) rotate(-45deg)',
      };
    case 'bottom-left':
      return {
        bottom: 0,
        left: 0,
        transform: 'translateY(100%) rotate(90deg) translateX(-70.71067811865476%) rotate(-45deg)',
        transformOrigin: 'top left',
        WebkitTransform:
          'translateY(100%) rotate(90deg) translateX(-70.71067811865476%) rotate(-45deg)',
      };
    case 'bottom-right':
      return {
        right: 0,
        bottom: 0,
        transform: 'translateY(100%) rotate(-90deg) translateX(70.71067811865476%) rotate(45deg)',
        transformOrigin: 'top right',
        WebkitTransform:
          'translateY(100%) rotate(-90deg) translateX(70.71067811865476%) rotate(45deg)',
      };
    default:
      return {};
  }
};

interface CornerRibbonProps {
  msg?: string;
  backgroundColor?: string;
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  className?: string;
}

const CornerRibbon: React.FC<CornerRibbonProps> = (props) => {
  /* TODO the designs want a ribbon that wraps more around the card; come back to make this better if time allows */
  const { msg = 'Premium', position = 'top-right', className, ...rest } = props;

  const positionStyle: React.CSSProperties = getPositionStyle(position);

  return (
    <Container className={className} {...rest}>
      <Ribbon style={positionStyle}>
        <Typography variant='p16Bold' color='secondary'>
          {t(msg)}
        </Typography>
      </Ribbon>
    </Container>
  );
};

export default CornerRibbon;
